import { Box } from '@mui/material';
import { FC } from 'react';
import { TInfoBlock } from '../../infoBlock.components';

export const RightColumn: FC<TRightColumn> = (props) => {
  const { rightColumn, rightColumnProps, isNotePinned, isAddressPinned } = props;

  return (
    <>
      {rightColumn && (
        <Box
          {...rightColumnProps}
          sx={{
            ...((isNotePinned || isAddressPinned) && {
              display: 'flex',
              flexDirection: 'column',
              maxHeight: '108px',
              overflowY: 'auto',
            }),
            ...rightColumnProps?.sx,
          }}
        >
          {rightColumn}
        </Box>
      )}
    </>
  );
};

type TRightColumn = Pick<
  TInfoBlock,
  'rightColumn' | 'rightColumnProps' | 'isNotePinned' | 'isAddressPinned'
>;
